var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCursor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.465 4.28501L9.776 19.612C9.82308 19.7262 9.89761 19.8269 9.99298 19.9053C10.0884 19.9838 10.2016 20.0374 10.3227 20.0616C10.4438 20.0857 10.569 20.0796 10.6871 20.0437C10.8053 20.0078 10.9127 19.9434 11 19.856L14.447 16.409L18.159 20.122C18.2999 20.2623 18.4907 20.341 18.6895 20.341C18.8883 20.341 19.0791 20.2623 19.22 20.122L20.28 19.061C20.3497 18.9914 20.405 18.9087 20.4427 18.8176C20.4804 18.7266 20.4998 18.629 20.4998 18.5305C20.4998 18.432 20.4804 18.3344 20.4427 18.2434C20.405 18.1524 20.3497 18.0697 20.28 18L16.568 14.288L20.015 10.841C20.1023 10.7537 20.1668 10.6462 20.2025 10.528C20.2383 10.4097 20.2444 10.2845 20.2201 10.1634C20.1959 10.0423 20.1421 9.9291 20.0636 9.83377C19.9851 9.73845 19.8842 9.66399 19.77 9.61701L4.444 3.30601C4.30709 3.24967 4.15657 3.2351 4.0114 3.26415C3.86623 3.2932 3.73291 3.36456 3.62822 3.46924C3.52354 3.57393 3.45218 3.70725 3.42313 3.85242C3.39408 3.99759 3.40865 4.14811 3.465 4.28501V4.28501Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursor);
export default __webpack_public_path__ + "static/media/Cursor.72dd0b26c570fffedc717ba67a0c3c7f.svg";
export { ForwardRef as ReactComponent };